module.exports = __webpack_public_path__ + "static/media/pdf-icon-png-pdf-zum-download-2.ab28a9d2.png";